import {
  defaultLoadableState,
  LoadableState,
  useLoadableState
} from '@carvana/merch-react-hooks';
import React, { createContext, useMemo } from 'react';
import { FeedData } from '~/services/home/contracts';

type NextBestActionContextType = {
  actions: LoadableState<FeedData | null>;
};

const defaultContext: NextBestActionContextType = {
  actions: defaultLoadableState<FeedData | null>(null)
};

const NextBestActionContext =
  createContext<NextBestActionContextType>(defaultContext);

export function NextBestActionContextProvider(props: React.PropsWithChildren) {
  const actions = useLoadableState<FeedData | null>(null);

  const value = useMemo<NextBestActionContextType>(
    () => ({ actions }),
    [actions]
  );

  return (
    <NextBestActionContext.Provider value={value}>
      {props.children}
    </NextBestActionContext.Provider>
  );
}

export function useNextBestActionIsLoaded() {
  const {
    actions: { isLoaded }
  } = React.useContext(NextBestActionContext);

  return isLoaded;
}

export default NextBestActionContext;
